import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllQuotes,
  loadSingleQuote,
  setSingleQuoteNotFound,
} from "./QuoteList.slice";

import { loadAllQuotesAPI, loadSingleQuoteAPI } from "./QuoteList.api";

export const LOAD_ALL_QUOTES = {
  LOADING: "Load all quotes loading",
  SUCCESS: "Load all quotes success",
  ERROR: "Load all quotes error",
};

export const LOAD_SINGLE_QUOTE = {
  LOADING: "Load single quote loading",
  SUCCESS: "Load single quote success",
  ERROR: "Load single quote error",
};

function* loadAllQuotesWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllQuotesAPI, payload);
    yield put(loadAllQuotes(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_QUOTES.ERROR, error });
  }
}

function* loadSingleQuoteSagaWorker(action) {
  yield put(setSingleQuoteNotFound(false));
  const { payload } = action;

  try {
    const data = yield call(loadSingleQuoteAPI, payload);
    yield put(loadSingleQuote(data));
  } catch (error) {
    if (isNotFoundError(error)) {
      yield put(setSingleQuoteNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_QUOTE.ERROR, error });
  }
}

export function* loadAllQuotesSaga() {
  yield takeLatest(LOAD_ALL_QUOTES.LOADING, loadAllQuotesWorker);
}

export function* loadSingleQuoteSaga() {
  yield takeLatest(LOAD_SINGLE_QUOTE.LOADING, loadSingleQuoteSagaWorker);
}
